module.exports = __webpack_public_path__ + "static/media/37.e19392e2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/borders/37.jpg
// module id = 727
// module chunks = 0